// src/utils/loggingUtils.js
export const logsRef = { current: [] };

export const log = (...args) => {
  console.log(...args);
  logsRef.current.push({ type: 'log', message: args.map(String).join(' ') });
};

export const warn = (...args) => {
  console.warn(...args);
  logsRef.current.push({ type: 'warn', message: args.map(String).join(' ') });
};

export const error = (...args) => {
  console.error(...args);
  logsRef.current.push({ type: 'error', message: args.map(String).join(' ') });
};

export const downloadJSON = () => {
  const jsonString = JSON.stringify(logsRef.current, null, 2);
  const blob = new Blob([jsonString], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'gltf_data.json';
  a.click();
  URL.revokeObjectURL(url);
};
